var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#0078D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32.5C20.7813 32.5 18.9062 30.3125 18.9062 28.75C18.9062 28.4375 19.0625 27.9687 19.375 27.8125C19.6875 27.5 20 27.5 20.3125 27.5C22.0312 27.5 21.5625 30.1562 25 30.1562C26.7188 30.1562 27.6563 29.0625 27.6563 28.125C27.6563 27.5 27.3437 26.875 26.25 26.5625L22.5 25.625C19.5313 24.8437 19.0625 23.125 19.0625 21.7187C19.0625 18.4375 22.0313 17.3438 24.8438 17.3438C27.3438 17.3438 30.4688 18.75 30.4688 20.625C30.4688 21.4062 29.8438 21.875 28.9062 21.875C27.3438 21.875 27.6563 19.6875 24.5313 19.6875C22.9688 19.6875 22.1875 20.4688 22.1875 21.4062C22.1875 22.3438 23.4375 22.8125 24.375 22.9688L27.1875 23.5938C30.1563 24.2188 30.9375 26.0938 30.9375 27.6563C30.9375 30.625 28.9062 32.5 25 32.5ZM36.5625 27.0312C36.7188 26.4062 36.7188 25.625 36.7188 25C36.7188 21.5625 35.1562 18.2812 32.5 15.9375C29.8437 13.5937 26.25 12.8125 22.8125 13.2812C21.875 12.8125 20.625 12.5 19.375 12.5C16.875 12.5 14.5313 13.9063 13.2813 16.0938C12.0313 18.2813 12.0313 20.9375 13.2813 23.125C12.6563 26.875 13.75 30.7812 16.5625 33.5938C19.2187 36.25 23.125 37.5 26.875 36.875C27.9688 37.5 29.0625 37.8125 30.3125 37.8125C32.8125 37.8125 35.1562 36.4062 36.4062 34.2188C37.6562 31.875 37.8125 29.2187 36.5625 27.0312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/Skype.6b8f28d79aed225f89ff50f5286a05c9.svg";
export { ForwardRef as ReactComponent };